import { useEffect } from 'react';
import { createContext, useState } from 'react';

const LoactionContext = createContext();

export const LocationContextProvider = ({ children }) => {
  const [locationData, setLocationData] = useState(null);
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    const fetcher = async () => {
      try {
        const res = await fetch('/api/user/addresses', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
              .content,
          },
        });
        const defLocationRes = await fetch(
          '/api/user/lastassr',
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
                .content,
            },
          }
        );

        const data = await res.json();
        const defLocationData = await defLocationRes.json();

        setLocationData({ data, defLocationData });
      } catch (error) {
        console.log(error);
      }
    };
    fetcher();
  }, [update]);

  const value = { locationData, setLocationData, setUpdate };

  return (
    <LoactionContext.Provider value={value}>
      {children}
    </LoactionContext.Provider>
  );
};

export default LoactionContext;
